import { InfoOutlined } from '@mui/icons-material'
import { Tooltip, useTheme } from '@mui/material'
import { ReactElement, ReactNode } from 'react'
import i18n from 'i18n'

interface ExplanationTooltipProps {
  title: ReactNode
  children?: ReactElement
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}

export default function ExplanationTooltip(props: ExplanationTooltipProps) {
  const theme = useTheme()
  return (
    <Tooltip
      sx={{
        marginLeft: i18n.dir() === 'ltr' ? 1 : 0,
        marginRight: i18n.dir() === 'rtl' ? 1 : 0
      }}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            padding: '12px',
            fontSize: '15px',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            margin: '4px !important',
            borderRadius: '20px',
            fontWeight: 400,

            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            border: '1px solid var(--color-border-overlay)',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
            '& .MuiTooltip-arrow::before': {
              backgroundColor: `${theme.palette.background.paper} !important`
            }
          }
        },
        popper: {
          sx: {
            zIndex: 999998
          }
        }
      }}
      title={props.title}
      placement={props.placement ?? 'top'}
    >
      {props.children ?? (
        <InfoOutlined
          sx={{
            marginLeft: i18n.dir() === 'ltr' ? 1 : 0,
            marginRight: i18n.dir() === 'rtl' ? 1 : 0,

            width: '16px !important',
            height: '16px !important'
          }}
        />
      )}
    </Tooltip>
  )
}
